import { Rarity } from '@stalker/core';

export const RARITY_COLORS: Record<string, string> = {
  common: 'text-muted-foreground',
  uncommon: 'text-accent',
  rare: 'text-primary',
  legendary: 'text-yellow-400',
};

export const RARITY_ENUM_TO_COLOR: Record<number, string> = {
  [Rarity.Common]: 'text-muted-foreground',
  [Rarity.Uncommon]: 'text-accent',
  [Rarity.Rare]: 'text-primary',
  [Rarity.Legendary]: 'text-yellow-400',
};

export const RARITY_BG: Record<string, string> = {
  common: 'bg-muted/10 border-muted/20',
  uncommon: 'bg-accent/10 border-accent/20',
  rare: 'bg-primary/10 border-primary/20',
  legendary: 'bg-yellow-500/10 border-yellow-500/20',
};

export const COLLECTION_COLORS: Record<string, string> = {
  construction: 'text-primary',
  container: 'text-muted-foreground',
  stationery: 'text-muted-foreground',
  storage: 'text-accent',
  technical: 'text-primary',
  elite: 'text-yellow-500',
};

export const LOCATION_TYPE_COLORS: Record<string, string> = {
  residential: 'border-accent/30 bg-accent/5 text-accent',
  school: 'border-primary/30 bg-primary/5 text-primary',
  shop: 'border-yellow-500/30 bg-yellow-500/5 text-yellow-500',
  hospital: 'border-red-900/30 bg-red-900/5 text-red-500',
  garage: 'border-muted/30 bg-muted/5 text-muted-foreground',
  military: 'border-red-600/30 bg-red-600/5 text-red-600',
  factory: 'border-primary/30 bg-primary/5 text-primary',
  church: 'border-muted/30 bg-muted/5 text-muted-foreground',
  hotel: 'border-accent/30 bg-accent/5 text-accent',
  library: 'border-primary/30 bg-primary/5 text-primary',
  bunker: 'border-red-500/30 bg-red-500/5 text-red-500',
};
